import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Checkbox } from 'components/forms'
import Clickable from 'components/clickable'
import { getFilteredProductsCount, FILTERS } from '../../helpers'

export const OnSaleFilterSection = ({
  products,
  onSale,
  setOnSale,
  selfExcludingFilters,
}) => {
  const filteredCount = getFilteredProductsCount(products, {
    ...selfExcludingFilters,
    [FILTERS.ON_SALE]: true,
  })
  const disabled = filteredCount === 0
  return (
    <Clickable
      onClick={() => {
        if (!disabled) setOnSale(!onSale)
      }}
      style={{ width: '100%' }}
      className={classnames('phxl', { disabled })}
      aria-label={`Click to ${onSale ? 'remove' : 'apply'} on-sale filter.`}
    >
      <div className="flex align-center">
        <div
          className={classnames('h7 flex grow text-uppercase text-bold', {
            'text-light': !disabled,
          })}
        >{`ON SALE (${filteredCount})`}</div>
        <Checkbox
          checked={onSale}
          className="man"
          disabled={filteredCount === 0}
          groupClassName="man pan"
          label={<span style={{ opacity: 0, width: 0 }}>On sale only</span>}
          size="large"
          style={{
            pointerEvents: 'none',
          }}
        />
      </div>
    </Clickable>
  )
}

OnSaleFilterSection.propTypes = {
  onSale: PropTypes.bool,
  products: PropTypes.array.isRequired,
  setOnSale: PropTypes.func.isRequired,
  selfExcludingFilters: PropTypes.object.isRequired,
}

OnSaleFilterSection.defaultProps = {
  onSale: undefined,
}
